// extracted by mini-css-extract-plugin
export default {"mainContainer":"BusinessAdvisory_mainContainer__OqABp","sectionHeading":"BusinessAdvisory_sectionHeading__QaNXE","filterContainer":"BusinessAdvisory_filterContainer__itTh8"};